// removed by extract-text-webpack-plugin
module.exports = {"ModalManagementOC":"Modales__ModalManagementOC___2CiEc","ModalManagementOC_infoMsg":"Modales__ModalManagementOC_infoMsg___1NXL3","ModalManagementOC_button_accept":"Modales__ModalManagementOC_button_accept___v4-Q9","ModalManagementOC_fixedWidth":"Modales__ModalManagementOC_fixedWidth___B0ktH"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/billing/management-oc/Modales.css
// module id = 1145
// module chunks = 0